import { ExtractPropTypes } from 'vue'

export const scrollPointProps = {
	/**
	 * 滚动点的标识值
	 */
	value: {
		type: [String, Number],
		default: '',
	},
}

export type ScrollPointProps = ExtractPropTypes<typeof scrollPointProps>

export interface ScrollPointInstance {
	/**
	 * 滚动点的DOM引用
	 */
	pointRef: HTMLElement | null
	/**
	 * 获取滚动点的标识值
	 */
	getValue: () => string | number
}
